module.exports = __webpack_public_path__ + "static/media/brain-logo.6151407b.svg";